import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Property enquiry", { props: { triggerType: "Form Submitted", event: "Listing enquiry" } }],
  ["s1", "auto-sms", "Reply within a minute", { props: { message: "Hi {{contact.first_name}} — got your enquiry on {{contact.listing}}. Want to see it this week?" } }],
  ["e1", "auto-email", "Three more like it", { props: { subject: "3 similar homes in {{contact.area}}" } }],
  ["w1", "auto-wait", "Wait 3 days", { props: { duration: "3", unit: "days" } }],
  ["k1", "auto-task", "Qualify: budget, timeline, finance", { props: { assignee: "Listing agent", due: "+2 days" } }],
  ["c1", "auto-condition", "Buying within 90 days?", { props: { condition: "buying_timeline is less than 90 days" } }],
  ["e2", "auto-email", "Book a viewing", { props: { subject: "Pick a viewing slot" } }],
  ["w2", "auto-wait", "Wait 2 weeks", { props: { duration: "2", unit: "weeks" } }],
  ["e3", "auto-email", "New this fortnight in your area", { props: { subject: "What's just come to market in {{contact.area}}" } }],
  ["tg", "auto-tag-add", "Tag: long-nurture", { props: { tag: "long-nurture" } }],
]);

const def: TemplateDef = {
  slug: "real-estate-buyer-nurture",
  name: "Real Estate Buyer Nurture",
  category: "Services",
  tagline:
    "Answer in a minute, qualify in a week, and stay useful for the eleven months after.",
  description:
    "A free real estate lead template: a portal enquiry gets an instant text and three comparable listings, an agent task qualifies budget and timeline, and buyers who aren't ready drop into a fortnightly new-listings nurture instead of being lost. Clone it into FrazzleCRM and run a long buying cycle without dropping anyone.",
  whatsInside: [
    "Instant SMS reply on enquiry — the whole game in portal leads",
    "Comparable-listings email that earns the second conversation",
    "Agent qualification task plus a 90-day timeline branch",
    "Fortnightly new-listings nurture for the buyers who aren't ready yet",
  ],
  flow: makeFlow(
    [
      node("src1", "traffic-seo", "Portal listings", 40, 60, { props: { keywords: "Rightmove / Zillow enquiries" } }),
      node("src2", "traffic-facebook", "Facebook Ads", 40, 220, { props: { campaign: "Local buyers" } }),
      node("lp", "page-web", "Listing page", 360, 140, { props: { pageType: "landing", headline: "3 bed semi, {{area}}" } }),
      flow("f1", "Buyer Nurture", 680, 40, 420, 1040),
      ...seq.nodes,
      node("bk", "page-booking", "Viewing slot", 1200, 340, { props: { duration: "30 min" } }),
      node("out", "outcome-appointment", "Viewing booked", 1520, 340),
      node("n1", "util-note", "The cycle is longer than your patience", 360, 340, {
        notes:
          "Most portal enquiries are not buying this month. The fortnightly listings email is the cheapest way to still be the agent they call when they are.",
      }),
    ],
    [
      edge("src1", "lp"),
      edge("src2", "lp"),
      edge("lp", "f1"),
      ...seq.edges,
      edge("f1", "bk"),
      edge("bk", "out"),
    ]
  ),
};

export default def;
